import { defineRecipe as t } from "@pandacss/dev";
const i = {
  exclusive: {
    background: "linear-gradient(55deg, #0E4160 0%, #4A7E8F 87.2%)",
    color: "text-white"
  },
  highlighted: {
    background: "linear-gradient(55deg, #80B7B3 0%, #D6F0ED 85.75%)",
    color: "#326D68"
  }
}, e = {
  small: {
    width: "fit-content",
    paddingTop: "0.5",
    paddingBottom: "0.5",
    paddingLeft: "1.5",
    paddingRight: "1.5",
    borderRadius: "1.5",
    fontSize: "sm",
    fontWeight: "medium",
    letterSpacing: "sm",
    lineHeight: "sm"
  },
  medium: {
    width: "fit-content",
    paddingTop: "1",
    paddingBottom: "1",
    paddingLeft: "2",
    paddingRight: "2",
    borderRadius: "2",
    fontSize: "sm",
    fontWeight: "medium",
    letterSpacing: "sm",
    lineHeight: "sm"
  },
  large: {
    width: "fit-content",
    paddingTop: "1",
    paddingBottom: "1",
    paddingLeft: "2",
    paddingRight: "2",
    borderRadius: "2",
    fontSize: "md",
    fontWeight: "medium",
    letterSpacing: "md",
    lineHeight: "md"
  }
}, n = t({
  className: "property-tag",
  variants: {
    variant: i,
    size: e
  },
  defaultVariants: {
    variant: "exclusive",
    size: "small"
  }
});
export {
  n as propertyTag
};
